import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-moon': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M342.8 352.7C348.5 343.1 352 332 352 320 352 284.7 323.3 256 288 256 270.8 256 255.2 262.9 243.7 273.9 227.4 244.3 196.2 224 160 224 107 224 64 267 64 320 64 322 64.5 323.8 64.6 325.7 27.1 338.8 0 374.1 0 416 0 469 43 512 96 512H336C380.2 512 416 476.2 416 432 416 390.1 383.7 356.2 342.8 352.7zM565.3 298.4C472.2 316.1 386.8 244.7 386.8 150.7 386.8 96.5 415.8 46.7 462.9 19.9 470.2 15.8 468.3 4.8 460.1 3.2 448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192 233.1 200.5 233.8 208.8 234.9 217 240.8 221.3 246.5 225.9 251.6 231.2 263 226.5 275.3 224 288 224 340.9 224 384 267.1 384 320 384 323.6 383.8 327.2 383.4 330.7 407 341.5 425.8 360.2 436.9 383.3 491.3 379.9 540.6 354 574 312.9 579.3 306.4 573.5 296.8 565.3 298.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-moon.js
// module id = wUVl
// module chunks = 144